// Issue #35 — open-redirect hardening for the post-login `next` query
// param. AuthCallback.jsx used to navigate to it with no validation at
// all; Login.jsx validated with `next.startsWith("/")`, which itself
// passes a protocol-relative value like `//evil.com` (browsers treat a
// leading `//` as "same scheme, different host" — startsWith("/") does
// not catch that). One shared validator used at both call sites so they
// can't diverge again.
//
// Requires a leading single slash and rejects a second leading slash or
// backslash (`//evil.com`, `/\evil.com` — both browser-navigable as
// protocol-relative cross-origin URLs in some contexts).
const SAFE_NEXT_PATH_RE = /^\/(?!\/|\\)/;

export function isSafeNextPath(value) {
    return typeof value === "string" && SAFE_NEXT_PATH_RE.test(value);
}

/** Returns `value` if it's a safe same-origin path, else `fallback`. */
export function safeNextPath(value, fallback = "/") {
    return isSafeNextPath(value) ? value : fallback;
}
